import React, { useState } from 'react';
import { Swiper, SwiperSlide, Autoplay, Pagination, TypeSwiper } from '../../services/ImportsSwiper';
import { Props } from './interfaces';
import './SliderMainBlock.scss';
import './SliderMainBlock-media.scss';
import PaginationBlock from '../Pagination/Pagination';

import { EnumUrlsPages } from '../../services/Enum';
import { MediaContent } from '../../services/GlobalFunctions';
import {Link} from "../Link/Link";

const SliderMainBlock = ({ slides }: Props) => {
  const [numActiveSlide, setNumActiveSlide] = useState(1);

  const Changed = (current: TypeSwiper) => setNumActiveSlide(current.realIndex + 1);

  const [slider, setSlider] = useState<TypeSwiper>();
  const settings = {
    autoplay: false,
    speed: 500,
    loop: true,
    modules: [Autoplay, Pagination],
    slidesPerView: 1,
    onSlideChange: Changed,
    className: 'slider-main-block',
    spaceBetween: 20,
  };

  const prevSlide = () => {
    if (slider) {
      slider.slidePrev(500, false);
    }
  };
  const nextSlide = () => {
    if (slider) {
      slider.slideNext(500, false);
    }
  };

  return slides.length ? (
    <Swiper {...settings} onInit={(slider: TypeSwiper) => setSlider(slider)}>
      {slides.map(({ alias, title, link, linkOut, image, uri }, i) => (
        <SwiperSlide key={i}>
          {linkOut ? (
            <a href={link} className="slider-main-block__content" target="_blank" key={i}>
              <CardContent title={title} image={image} />
            </a>
          ) : (
            <Link to={uri || ''} className="slider-main-block__content" key={i}>
              <CardContent title={title} image={image} />
            </Link>
          )}
        </SwiperSlide>
      ))}

      <div className="slider-main-block__dots">
        <PaginationBlock small current={numActiveSlide} all={slides.length} />
        <div className="slider-main-block__arrows">
          <div className="slider-main-block__arrow slider-main-block__arrow_prev" onClick={prevSlide}></div>
          <div className="slider-main-block__arrow slider-main-block__arrow_next" onClick={nextSlide}></div>
        </div>
      </div>
    </Swiper>
  ) : null;
};

export default SliderMainBlock;

const CardContent = ({ title, image }: { title: string; image: string | null | undefined }) => {
  return (
    <>
      <div
        className="slider-main-block__new"
        style={image ? { backgroundImage: `url(${image})` } : {}}
      />

      <span className="slider-main-block__gap" />
      <div className="slider-main-block__info">
        {MediaContent(
          <h4 className="slider-main-block__new-title">{title}</h4>,
          <h5 className="slider-main-block__new-title">{title}</h5>
        )}
      </div>
    </>
  );
};
